import React from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import { COLOR_MAP } from "../../../constants/ColorNames";
import EditIcon from "../../../constants/icons/EditIcon";

interface IProps {
  children?: React.ReactNode;
  title: string;
  subTitle?: string;
  isEditMode: boolean;
  stepsCompleted: number;
  handleEditClick: (step: number) => void;
  stepNumber: number;
}

const Accordion: React.FC<IProps> = ({
  children,
  isEditMode,
  title,
  subTitle,
  stepsCompleted,
  handleEditClick,
  stepNumber,
}) => {
  const isCurrentStepCompleted = stepNumber < stepsCompleted;
  const showEdit = !isEditMode && stepNumber <= stepsCompleted;

  const getColor = () => {
    if (!isEditMode && isCurrentStepCompleted) {
      return COLOR_MAP.WHITE;
    }

    if (!isEditMode && !isCurrentStepCompleted && !showEdit) {
      return "grey";
    }

    return "inherit";
  };

  return (
    <Paper
      sx={{
        p: 2,
        mb: 2,
        borderRadius: "8px",
      }}
      variant="outlined"
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            alignItems: "center",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          <Box sx={{ width: "30px" }}>
            <Box
              sx={{
                borderRadius: "50%",
                border: `0.1rem solid`,
                mr: 1,
                height: 18,
                width: 18,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "fontWeightBold",
                color: getColor(),
                backgroundColor:
                  !isEditMode && isCurrentStepCompleted
                    ? COLOR_MAP.GREEN_DARK
                    : "inherit",
              }}
            >
              {stepNumber + 1}
            </Box>
          </Box>
          <Typography
            sx={{
              mr: 1,
              fontWeight: "fontWeightBold",
              ...(!isEditMode &&
                !isCurrentStepCompleted &&
                !showEdit && {
                  color: "grey",
                }),
            }}
            variant="h5"
          >
            {title}
          </Typography>

          {showEdit && (
            <Typography variant="h6" sx={{ color: "grey" }}>
              {subTitle}
            </Typography>
          )}
        </Box>
        {showEdit && (
          <Button
            sx={{ p: 0, textTransform: "none" }}
            variant="text"
            startIcon={
              <EditIcon
                fill={COLOR_MAP.DARK_PURPLE}
                pathFill={COLOR_MAP.DARK_PURPLE}
                height="18px"
                width="18px"
              />
            }
            disableRipple
            onClick={() => handleEditClick(stepNumber)}
          >
            Edit
          </Button>
        )}
      </Box>
      {isEditMode ? children : null}
    </Paper>
  );
};

export default Accordion;
